import React from 'react'
import {Segment, Breadcrumb, Modal, Button, Icon, Header, Placeholder, Table, Label, Popup} from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import * as routerActions from '../../actions/RouterActions'
import {StoreDetails} from './store.js'
import {Route} from '../Router.js'

export default function Storelist(props) {
    const filter_to_caption = {
        'valid': 'Gültige Einträge',
        'missing_geocode': 'Einträge ohne Location API Treffer',
        'missing_address': 'Formatfehler',
        'item_on_blacklist': 'Gesperrte Einträge'
    };

    const firestore = useFirestore();
    const lotteryId = props.match.params.lotteryId;
    const filter = (typeof props.match.params.filter !== 'undefined' && props.match.params.filter !== 'store')?props.match.params.filter:null;
    const dispatch = useDispatch()

    useFirestoreConnect([
        { collection: 'environments/dev/store-locator/' + lotteryId + '/stores' },
        { collection: 'environments/dev/lotteries', doc: lotteryId }
    ])

    const lottery = useSelector(({ firestore: { data } }) => data['environments/dev/lotteries'] && data['environments/dev/lotteries'][lotteryId])
    const stores = useSelector(state => state.firestore.ordered['environments/dev/store-locator/' + lotteryId + '/stores']);

    function isValid(store){
        if(typeof store.geocode !== 'undefined' && store.geocode !== null)return true;
        return false;
    }

    function getError(store){
        if(typeof store.geocode !== 'undefined' && store.geocode !== null)return null;
        
        if(store.valid){
            return 'missing_geocode';
        }else{
            return store.error;
        }
    }

    const getNameForFilter = (filter) => (typeof filter_to_caption[filter] !== 'undefined')?filter_to_caption[filter]:filter;

    return (
            <div>
                <Route path="/storelocator/stores/:lotteryId/:filter?/store/:storeId" component={StoreDetails} />
                <div style={{
                    marginTop: '-60px',
                    paddingTop: '20px',
                    height: '60px',
                    position: 'fixed',
                    width: '100%',
                    backgroundColor: '#FFFFFF'
                }}>
                    <Breadcrumb style={{
                        paddingLeft: '20px',
                        marginLeft: '20px',
                    }}>
                        <Breadcrumb.Section link onClick={() => dispatch(routerActions.push('storelocator/'))}>Store-Locator</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right angle' />
                        {
                            (typeof lottery === 'undefined')?
                                <Placeholder><Placeholder.Line /></Placeholder>
                            :
                                <Breadcrumb.Section link onClick={() => dispatch(routerActions.push('storelocator/stores/' + lotteryId))}>{lottery.state}</Breadcrumb.Section>
                        }
                        {
                            (filter !== null)?
                                <span>
                                    <Breadcrumb.Divider icon='right angle' />
                                    <Breadcrumb.Section>
                                        {
                                            getNameForFilter(filter)
                                        }
                                    </Breadcrumb.Section>
                                </span>
                            :null
                        }
                    </Breadcrumb>
                </div>
                <div style={{
                    marginTop: '60px'
                }}>
                    {
                        (typeof stores === 'undefined')?
                            <Placeholder>
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                            </Placeholder>
                        :
                        <Table basic="very" padded fixed>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}></Table.HeaderCell>
                                    <Table.HeaderCell width={2}>ID</Table.HeaderCell>
                                    <Table.HeaderCell width={5}>Adresse</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {            
                                    Object.keys(stores).map(
                                        (key, id) => {
                                            if(filter !== null){
                                                if(filter === 'valid' && !isValid(stores[key]))return null;
                                                if(filter !== 'valid' && isValid(stores[key]))return null;
                                                if(filter !== 'valid' && getError(stores[key]) !== filter)return null;
                                            }
                                            return (
                                                    <Table.Row>
                                                        <Table.Cell textAlign="center">
                                                                {
                                                                    (isValid(stores[key]))?
                                                                        <Icon color='teal' circular name="checkmark" bordered inverted />
                                                                    :
                                                                        (getError(stores[key]) === 'missing_geocode')?
                                                                            <Popup inverted size="small" position='left center' content='Für diese Adresse konnten keine Informationen über die Google Location API gefunden werden.' trigger={
                                                                                <Icon.Group size="big">
                                                                                    <Icon name="google" circular size="tiny" inverted color="grey"/>
                                                                                    <Icon corner='top right' name='question circle' color="red" />
                                                                                </Icon.Group>
                                                                            } />
                                                                        :
                                                                            (getError(stores[key]) === 'missing_address')?
                                                                                <Popup inverted size="small" position='left center' content='Formatfehler: Für diese Eintrag konnte keine gültige Adresse aus den Rohdaten extrahiert werden.' trigger={
                                                                                    <Icon.Group size="big">
                                                                                        <Icon name="filter" circular size="tiny" inverted color="grey"/>
                                                                                        <Icon corner='top right' name='question circle' color="red" />
                                                                                    </Icon.Group>
                                                                                } />
                                                                            :
                                                                                (getError(stores[key]) === 'item_on_blacklist')?
                                                                                    <Popup inverted size="small" position='left center' content='Formatfehler: Für diese Eintrag konnte keine gültige Adresse aus den Rohdaten extrahiert werden.' trigger={
                                                                                        <Icon color='black' name="ban" />
                                                                                    } />
                                                                                :
                                                                                    <Popup inverted size="small" position='left center' content={'Unbekannter Fehler: ' + getError(stores[key]) } trigger={
                                                                                        <Icon color='red' circular name="bug" bordered inverted />
                                                                                    } />
                                                                }
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <a href="#" onClick={() => dispatch(routerActions.push('storelocator/stores/' + lotteryId + ((filter)?('/' + filter):'') + '/store/' + stores[key].id))}>{stores[key].id}</a>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {
                                                                (typeof stores[key].geocode !== 'undefined')?
                                                                    stores[key].geocode.formatted_address
                                                                :
                                                                    (getError(stores[key]) === 'missing_geocode')?
                                                                        <i style={{
                                                                            color: "#FF0000"
                                                                        }}>
                                                                            Adresse für Location-Suche: {stores[key].street}, {stores[key].city}, {stores[key].country}
                                                                        </i>
                                                                    :
                                                                        (getError(stores[key]) === 'missing_address')?
                                                                        <i style={{
                                                                            color: "#FF0000"
                                                                        }}>
                                                                            Rohdaten: {stores[key].source}
                                                                        </i>
                                                                        :null
                                                            }
                                                        </Table.Cell>
                                                    </Table.Row>
                                            )
                                                
                                        }
                                    )
                                }
                            </Table.Body>
                        </Table>
                    }
                    </div>
        </div>
    )
}